import type { Assistant, AssistantFeature } from './types';

export const CABIN_CONFIG_ASSISTANT_ID = 'cabin';
export const CABIN_CONFIG_FEATURE_ID = 'cabinConfig';

export const cabinConfigAssistant: Assistant = {
  id: CABIN_CONFIG_ASSISTANT_ID,
  name: '客舱规划师',
  description: '机队飞机 ≥30 架，或经营至第 104 周后解锁。招募后可按航线市场特征调整单架飞机的舱位配比。',
  featureIds: [CABIN_CONFIG_FEATURE_ID],
  unlocked: (state) => state.aircraft.length >= 30 || state.week >= 104,
  unlockRequirement: '机队飞机 ≥30 架，或经营至第 104 周',
  recruitCost: 120_000,
  weeklySalary: 5_000,
};

export const cabinConfigFeature: AssistantFeature = {
  id: CABIN_CONFIG_FEATURE_ID,
  name: '客舱布局调整',
  description: '允许将单架飞机的经济/商务/头等舱座位在机型总座位约束内重新分配。',
  assistantId: CABIN_CONFIG_ASSISTANT_ID,
};
